import React, {useState,useEffect,useContext,useRef} from "react";
import { useLocation,useNavigate } from 'react-router-dom'
import { useForm, Controller  } from 'react-hook-form';
import Lang from '../lang/translations';
import Auth from '../../userServices/authServices';
import Context from '../context/context';

import ReactGA from 'react-ga4';
import helpersFunction from "../_helpers/helpersFunction";
import queryString from 'query-string';
const config = require("../_helpers/configServizi");


export default function Signup(props) {
    const  context = useContext(Context)

	const [errore, setErrore] = useState("");
	const [spinner, setSpinner] = useState(false);
	const [ciudad, setCiudad] = useState(Lang( {"w": "regione","page": "signupForm"} ));
	const [bottoneForm, setBottoneForm] = useState(Lang( {"w": "registrati_gratis","page": "signupForm"} ));
	const [switchForm, setSwitchForm] = useState(Lang( {"w": "gia_registrato","page": "signupForm"} ));
	const [tipoForm, setTipoForm] = useState(context.tipoForm ? context.tipoForm : "registrazione");
	const { register, handleSubmit, control  } = useForm();
	const [regioni, setRegioni] = useState({});
	const [formError, setFormError] = useState({email:false,password:false,geo:false});

	const [email, setEmail] = useState();
  	
    let navigate = useNavigate();
 
	var location = useLocation();
	location = location.pathname.split("/")


	function campiVuoti(data){
        var tmpObj = formError
      
        data.geo.length == 0 ? tmpObj.geo=true : tmpObj.geo= false
       
        setFormError(tmpObj)

		if(tmpObj.geo){
			setErrore(Lang( {"w": "errore_citta","page": "signupForm"} ));
			return true
		}

		return false
        
    }
	
    const onSubmit = (data) => {
		
		try{
			setSpinner(true);
			setErrore("");

			if(campiVuoti(data)){
				setSpinner(false);
				return
			}
		
			const domain = window.location.hostname;

			data.source = localStorage.getItem('source') ? localStorage.getItem('source') : null
			data.country = localStorage.getItem('country') ? localStorage.getItem('country') : helpersFunction.getCountry()
			data.campid = localStorage.getItem('campid') ? localStorage.getItem('campid') : ""
			data.city = ""
			data.region = data.geo.state_title ? data.geo.state_title : data.geo
			data.provincia = ""
			data.email =  email;
			data.password =  Math.random().toString(36).slice(2)
			data.ip = localStorage.getItem('ip') ? localStorage.getItem('ip') : null;
			data.clickid=localStorage.getItem('trackerId') ? localStorage.getItem('trackerId') : Math.random().toString(36).slice(2);
			data.fluxId = config.servizi[domain].default_fluxid
			data.servizio =  window.location.hostname;
						
			
			Auth.register(data)
			.then(res => {

				if(res.token){
					helpersFunction.setUser(res,context,true,true)
					helpersFunction.setAnalyticsDimensions(data.clickid,data.source,data.country,data.fluxId,true)
					
				}else{
					setErrore(helpersFunction.errorCodes(res));
					setSpinner(false); 
				}
				
			}).catch((err)=>{
				helpersFunction.logToBackend("problemi su signup",{err:err.message,clickid:localStorage.getItem('trackerId')})
				setSpinner(false)
				
			})
		}catch(err){
			helpersFunction.logToBackend("problemi su signup try catch",{err:err.message,clickid:localStorage.getItem('trackerId')})
			setSpinner(false)
		}

		
		
		
	};

    useEffect(() => { 

        //form registrazione
        const query = queryString.parse(window.location.search);
        if(query.mail){
            setEmail(query.mail)
        }else{
            helpersFunction.logToBackend("network non ha passato email",{query:window.location.search})
            console.log("No passata mail")
            navigate('/find'+window.location.search);
        }
        
       
        setBottoneForm(Lang( { "w":"pulsante", "page":"landingAutologin" } ));
        setSwitchForm(Lang( {"w": "gia_registrato","page": "signupForm"} ));
        setTipoForm("registrazione");
		
		helpersFunction.getRegionsByCountry()
            .then(res => {
                setRegioni(res)
            })
	
	},[]);


   

    function Spinner(){
		if(spinner){
			return (<div className="spinner-border text-light" role="status">
		  <span className="sr-only"><Lang w={"caricando"} page={"signupForm"}/></span>
		</div>);
		}else{
			return (<div></div>);
		}
	}


	
    function handleInputChange(target) {
		const value = target.currentTarget.value;
	
		if (target.currentTarget.name === "geo") {
			console.log(value.length)
			value.length > 0 ? setFormError({...formError,geo:false}) : setFormError({...formError,geo:true})
		}
	}

    return (
        
            <div className="all-container">
                <div className="filters-no-padding" role="main">
                    <div className="landerAutoSignupContainer">
                        <img className="bustaLanderAutoSignup" src="/img/love-message.svg"/>
                    </div>
                    <h1><Lang w={"titolone"} page={"landingAutosignup"}/></h1>
                    <p><Lang w={"testo"} page={"landingAutosignup"}/></p>
                </div>
        
                <form className={"formSignup mt20"} onSubmit={handleSubmit(onSubmit)}>
                
                    <label for="geo">{ciudad}</label>
                    <select name="geo" {... register('geo')}  onChange={(e) => handleInputChange(e)} className={formError.geo && ("errorCardInput")}>
                        <option selected disabled hidden value="">{ciudad}*</option>
                        { regioni.length > 0 && 
                            (
                                regioni.map(el=>(
                                <option value={el}>{el}</option>
                                    
                                ))
                            ) 
                        }
                    </select>
                                        
                    {errore && (<p className='erroreSignup'>{errore}</p>)}
                    <Spinner/>

                    <input type="submit" value={bottoneForm} disabled={spinner}></input>

                </form>
            </div>
    )
	
}